import { render, staticRenderFns } from "./SelectRuoliMantra.vue?vue&type=template&id=78f0e5a2&scoped=true&"
import script from "./SelectRuoliMantra.vue?vue&type=script&lang=js&"
export * from "./SelectRuoliMantra.vue?vue&type=script&lang=js&"
import style0 from "./SelectRuoliMantra.vue?vue&type=style&index=0&id=78f0e5a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f0e5a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f0e5a2')) {
      api.createRecord('78f0e5a2', component.options)
    } else {
      api.reload('78f0e5a2', component.options)
    }
    module.hot.accept("./SelectRuoliMantra.vue?vue&type=template&id=78f0e5a2&scoped=true&", function () {
      api.rerender('78f0e5a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SelectRuoliMantra.vue"
export default component.exports